<template>
  <header id="header" class="main">
    <a href="#" class="menu_btn">메뉴열기</a>
    <h1 class="logo" style="margin-right: 53px">
      <router-link to="/common.do?method=main">동행복권</router-link>
    </h1>

    <router-link
      to="/userSsl.do?method=myPage"
      class="mypage"
      style="float: right; position: absolute; right: 0px; top: 0px"
      v-if="!this.$store.state.isAuthenticated"
      >마이페이지</router-link
    >
    <div style="float: right; position: absolute; right: 0px; top: 0px" v-else>
      <ul>
        <li>
          <router-link to="/userSsl.do?method=myPage">
            <span
              style="
                position: relative;
                top: 25px;
                right: 5px;
                font-size: small;
              "
              ><strong
                >{{ this.$store.state.info.iu_name }}({{
                  this.$store.state.info.iu_nick_name
                }})</strong
              ></span
            ></router-link
          >
          <router-link to="/userSsl.do?method=myPage" class="mypage"
            >마이페이지</router-link
          >
        </li>
      </ul>
    </div>

    <nav id="gnb">
      <div class="inner">
        <div class="btns">
          <router-link to="/common.do?method=main" class="home"
            >홈으로 가기</router-link
          >
          <strong class="logo">동행복권</strong>
          <a href="#" class="close">메뉴닫기</a>
        </div>
        <div class="menu" id="mainMenu">
          <ul>
            <li>
              <h2 class="">
                <a href="#">당첨결과</a
                ><!-- 180829 -->
              </h2>
              <ul style="display: none">
                <li><a href="javascript:;">로또6/45</a></li>
                <li><a href="javascript:;">연금복권720+</a></li>
                <li><a href="javascript:;">전자복권</a></li>
                <li><a href="javascript:;">로또6/45 당첨통계</a></li>
                <li><a href="javascript:;">연금복권720+ 당첨통계</a></li>
                <li><a href="javascript:;">로또6/45 미수령 당첨금</a></li>
                <li><a href="javascript:;">당첨자인터뷰</a></li>
              </ul>
            </li>
            <li>
              <h2>
                <a href="javascript:;">판매점</a>
              </h2>
              <ul style="">
                <li><a href="javascript:;">복권 판매점</a></li>
                <li><a href="javascript:;">당첨 판매점</a></li>
              </ul>
            </li>
            <li>
              <h2>
                <router-link to="/service.do?method=eventList"
                  >이벤트</router-link
                >
              </h2>
              <ul style="">
                <li>
                  <router-link to="/service.do?method=eventList"
                    >이벤트</router-link
                  >
                </li>
                <!-- <li><a href="event.do?method=chipInfo">클로버칩 적립</a></li>
                    <li><a href="event.do?method=chipWishList">클로버칩 사용</a></li> -->
              </ul>
            </li>
            <li>
              <h2>
                <a href="javascript:;">행복공감</a>
              </h2>
              <ul style="">
                <li><a href="javascript:;">건전한 복권문화</a></li>
                <li><a href="javascript:;">복권 과몰입 예방법</a></li>
                <li><a href="javascript:;">복권기금</a></li>
              </ul>
            </li>
            <li>
              <h2 class="">
                <a href="#">마이페이지</a>
              </h2>
              <ul style="display: none">
                <li
                  :class="
                    $route.name === 'lottoBuyListView' &&
                    $route.query.method === 'lottoBuyListView'
                      ? 'active'
                      : ''
                  "
                >
                  <a href="/myPage.do?method=lottoBuyListView"
                    ><span> 구매당첨내역</span></a
                  >
                </li>
                <li
                  :class="
                    $route.name === 'lottoBuyListView' &&
                    $route.query.method === 'depositListView'
                      ? 'active'
                      : ''
                  "
                >
                  <a href="/myPage.do?method=depositListView"
                    ><span> 예치금</span></a
                  >
                </li>
                <li :class="$route.name === 'Payment' ? 'active' : ''">
                  <a href="/payment.do?method=payment"
                    ><span> 충전하기</span></a
                  >
                </li>
                <li
                  :class="
                    $route.name === 'MyPage' &&
                    $route.query.method === 'refundView'
                      ? 'active'
                      : ''
                  "
                >
                  <a href="/userSsl.do?method=refundView"
                    ><span> 출금신청</span></a
                  >
                </li>
                <li :class="$route.name === 'Counsel' ? 'active' : ''">
                  <a href="/counsel.do?method=myCounselList"
                    ><span> 고객센터</span></a
                  >
                </li>
                <li
                  :class="
                    $route.name === 'BoardList' &&
                    $route.query.method === 'noticeList'
                      ? 'active'
                      : ''
                  "
                >
                  <a href="/service.do?method=noticeList"
                    ><span> 공지사항</span></a
                  >
                </li>
                <li
                  :class="
                    $route.name === 'BoardList' &&
                    $route.query.method === 'eventList'
                      ? 'active'
                      : ''
                  "
                >
                  <a href="/service.do?method=eventList"
                    ><span> 이벤트</span></a
                  >
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="shortcut">
          <ul>
            <li>
              <a href="/counsel.do?method=myCounselList">고객센터</a>
            </li>
            <li>
              <a href="/service.do?method=noticeList">공지사항</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      notificationCount: 0,
      leftDrawer: false,
      leagueList: [],
      activeSport: null,
    };
  },
  mounted() {
    setTimeout(() => {
      this.getNotificationCount();
    }, 2000);
    this.getMyInformation();
    this.loginCheck();
    // this.getLeagueList();

    setInterval(() => {
      this.getNotificationCount();
      this.getMyInformation();
    }, 15000);

    setInterval(() => {
      this.loginCheck();
    }, 3000);
  },
  methods: {
    logout() {
      this.$store
        .dispatch("logout", {})
        .then(() => (window.location.href = "/"))
        .catch(({ message }) => alert(message));
    },
    getBalanceInformation() {
      if (this.$store.state.isAuthenticated) {
        this.$store.state.balance.wallet = "...";
        this.$store.state.balance.casino = "...";
        this.$store.state.balance.point = "...";
        this.$store.dispatch("getBalance");
      }
    },
    getMyInformation() {
      if (this.$store.state.isAuthenticated) {
        this.$store.dispatch("getInfo");
      }
    },
    getNotificationCount() {
      if (this.$store.state.isAuthenticated) {
        this.$axios.get("/web/my/notification/count", {}).then((res) => {
          this.notificationCount = res.data.count;
          if (res.data.count > 0 && this.$route.name !== "Message") {
            window.alert(this.$t("alert.unreadMessage"));
            this.$router.push({ name: "Message" });
          }
        });
      }
    },
    exchangePoint() {
      window
        .confirm(
          this.$t("alert.exchangePoint"),
          this.$t("alert.exchangePointTitle")
        )
        .then(() => {
          this.$axios
            .post("/web/my/point", {})
            .then((res) => {
              window.alert(res.data.message);
              this.$store.dispatch("getBalance");
            })
            .catch((err) => window.alert(err.response.data.message));
        });
    },
    loginCheck() {
      if (this.$store.state.isAuthenticated) {
        this.$axios
          .get("/web/check/login")
          .then((res) => {})
          .catch((err) => {
            // this.$alert(err.response.data.message);
          });
      }
    },
    getLeagueList() {
      this.$axios.get("/web/sports/league", {}).then((res) => {
        this.leagueList = res.data;
      });
    },
    selectSport(e) {
      this.activeSport === e
        ? (this.activeSport = null)
        : (this.activeSport = e);
    },
    moveToSports(e, k) {
      this.$router.push({
        name: "Sports",
        params: { kind: e, scope: "cross", league: k },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.long-quick-btn {
  position: relative;
  span {
    position: absolute;
    top: 48%;
    left: 53%;
    transform: translate(-50%, -50%);
    font-size: 15px;
  }
}

header {
  width: 100%;
  height: 60px;
  margin: 0 auto;
  line-height: 50px;
  position: relative;
  background: #141414;
  border-bottom: 1px solid #ffe256;

  .header-btn-box {
    width: 40px;
    height: 40px;
    font-size: 25px;
    color: #ffe35c;
    position: absolute;
    top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    cursor: pointer;
    &.left-btn-box {
      left: 10px;
    }

    &.right-btn-box {
      right: 10px;
    }
  }

  .logo-box {
    height: 60px;
    position: absolute;
    overflow: hidden;
    left: 50%;
    transform: translateX(-50%);
    top: 15px;
    a {
      display: flex;
    }

    img {
      width: 50px;
    }
  }

  .right-items-box {
    display: flex;
    align-items: center;
    margin-bottom: 55px;
    flex-wrap: wrap;
    justify-content: flex-end;

    .top-user-info {
      display: flex;
      flex-flow: column;
      font-size: 14px;
      font-weight: bold;
      margin-right: 10px;
      text-align: right;
      background: rgb(0 0 0 / 67%);
      padding: 5px 15px;
      border-radius: 5px;
      span {
        line-height: 20px;
      }
    }

    .top-balance-info {
      line-height: 20px;
      margin-top: -20px;
      background: rgba(0, 0, 0, 0.67);
      padding: 5px 15px;
      border-radius: 5px;
      font-size: 14px;
      font-weight: bold;
    }

    .top-input {
      font-family: "YoonGothic340";
      border: 1px solid #71522f;
      border-radius: 5px;
      background: #000000;
      margin-left: 5px;
      line-height: 34px;
      text-indent: 5px;
      width: 100px;
      color: white;
      &::placeholder {
        color: #949494;
      }
      &:focus-visible {
        outline: none;
        border-color: #bf8c4a;
      }
    }
  }
}

.info-nav-box {
  display: flex;
  padding: 10px;
  background: linear-gradient(180deg, #313131, #151515);
  font-family: AppleSDGothicNeoEB;
  font-size: 13px;
  align-items: center;
  justify-content: space-between;

  div {
    display: flex;
    align-items: center;
    margin-right: 5px;

    img {
      margin-right: 10px;
      height: 17px;
    }
  }

  .info-nav-divider {
    margin: 0 5px;
  }
}

.ld-close-btn {
  font-size: 30px;
  color: #52d6af;
  cursor: pointer;
  display: flex;
  align-items: center;
  // justify-content: space-between;
  padding-left: 5px;
  // padding: 10px 0;
  position: fixed;
  top: 0;
  right: 0;

  img {
    height: 30px;
    margin-left: calc(100vw - 330px);
    margin-right: 5px;
  }
  i {
  }
}

.ld-login-wrapper {
  display: flex;
  flex-flow: column;
  .ld-input {
    font-family: "YoonGothic340";
    border: 1px solid #71522f;
    border-radius: 5px;
    background: #000000;
    line-height: 34px;
    text-indent: 5px;
    width: 100%;
    color: white;
    &:focus-visible {
      outline: none;
      border-color: #bf8c4a;
    }
  }
  .yul-button {
    margin-left: 0;
    width: 100%;
    margin-top: 5px;
    &:last-child {
      margin-bottom: 10px;
    }
  }
}

.ld-user-info-wrapper {
  display: flex;
  flex-flow: column;
  margin-bottom: 10px;
  background-color: #4b371e;
  border: 1px solid #392915;
  font-family: "YoonGothic340";
  font-size: 12px;
  .ld-user-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 30px;
    padding: 0 10px;
    &:not(:last-child) {
      border-bottom: 1px solid #392915;
    }
    span {
      &:nth-child(1) {
        color: #e8d4bb;
      }
      &:nth-child(2) {
        color: #ffde00;
        font-weight: bold;
      }
    }
  }
}

.ld-img-menu {
  margin-bottom: 10px;
  a {
    display: block;
  }
}

.ld-buttons-wrapper {
  gap: 0px;
  .ld-button {
    font-family: "YoonGothic340";
    background: rgb(48, 26, 6);
    background: linear-gradient(
      0deg,
      rgba(48, 26, 6, 1) 0%,
      rgba(105, 55, 7, 1) 47%,
      rgba(221, 164, 97, 1) 100%
    );
    text-align: center;
    line-height: 35px;
    font-size: 13px;
    cursor: pointer;
  }
}

.sidebar-button {
  border-radius: 4px;
  height: 35px;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "SCDream7";

  a {
    color: white;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    gap: 5px;
    img {
      height: 20px;
    }
  }

  i {
    font-size: 20px;
    display: flex;
    margin-right: 5px;
    color: #52d6af;
  }
}

.reload-button {
  width: 16px;
  vertical-align: text-top;
  cursor: pointer;
}
.el-drawer__body {
  .side-menu-box {
    background-color: #0a0a0a;
    width: 100%;
    text-align: center;
    font-size: 17px;
    font-family: "AppleSDGothicNeoEB";
    padding: 15px 0;
    background-size: 100%;
  }
}

.line-gray {
  width: 250px;
  height: 1px;
  background-color: #252525;
}
.line-mint {
  width: 250px;
  height: 1px;
  background-color: #52d6af;
}
.side-menu-section {
  padding: 20px 20px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  gap: 20px;
  background-color: #0a0a0a;
  .quick-menu-btn {
    &:nth-child(1) {
      grid-column: span 3;
    }
    &.mt-30 {
      margin-top: 30px;
    }
    display: inline-block;
    width: 100%;
    text-align: center;
    font-size: 20px;
    img {
      display: block;
      width: 100%;
      margin: 0 auto;
    }
  }
  span {
    font-size: 13px;
    font-weight: bold;
  }
  .quick-menu-btn:nth-child(odd) {
    // margin-right: 25px;
  }
}
</style>
